'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdForward5 = function MdForward5(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.5 22.7c-0.1 0-0.5 0.1-0.5 0.3 0 0.1-0.2 0.2-0.2 0.2h-1l0.4-3.7h4v1.2h-2.9l-0.2 1.5s0.2 0 0.2-0.2 0.2 0 0.2-0.2 0.2 0 0.3 0h0.4c0.3 0 0.7 0.1 0.8 0.2s0.5 0.3 0.6 0.5c0.4 0.3 0.7 1.1 0.7 1.8 0 0.3 0 0.7-0.1 0.9s-0.2 0.5-0.6 0.8c-0.4 0.5-1 0.6-1.8 0.6-0.3 0-0.7 0-0.8-0.1s-0.5-0.2-0.8-0.3c-0.4-0.2-0.7-0.9-0.7-1.5h1.3c0 0.6 0.4 0.8 1 0.8 0.2 0 0.4 0 0.5-0.2l0.4-0.3s0.2-0.3 0.2-0.5v-1l-0.2-0.3-0.4-0.4s-0.3-0.1-0.5-0.1h-0.3z m-12.9-1.1c0-7.3 6.1-13.2 13.4-13.2v-6.8l8.4 8.4-8.4 8.4v-6.8c-5.5 0-10 4.6-10 10s4.5 10 10 10 10-4.5 10-10h3.4c0 7.4-6.1 13.4-13.4 13.4s-13.4-6-13.4-13.4z' })
        )
    );
};

exports.default = MdForward5;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/forward-5.js
// module id = 2899
// module chunks = 0